import { AxiosResponse } from "axios"
import ConnectApi from "../baseService"
import { TApiResponse } from "../TApiResponse"
import {
  TTabletTenkoGetListReq,
  TTabletTenkoGetListRes,
  TTabletUpsertTenkoHeaderPostReq,
  TTabletUpsertTenkoHeaderPostRes,
} from "./TTabletTenko"

/**
 * 取込ファイルに対するAPIリクエスト用サービス
 *
 * @export
 * @class TabletTenkoService
 * @extends {ConnectApi}
 */
export default class TabletTenkoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TTabletTenkoGetListReq} params
   * @memberof TabletTenkoService
   */
  getList = async (params: TTabletTenkoGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTabletTenkoGetListRes>> =
        await this.getInner(`/tablet/tenko/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  upsertTenkoHeader = async (params: TTabletUpsertTenkoHeaderPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTabletUpsertTenkoHeaderPostRes>> =
        await this.postInner(`/tablet/tenkoheader/upsert`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
